export enum UtilisateurRole {
  DEMANDEUR = 'DEMANDEUR',
  REPRESENTANT = 'REPRESENTANT',
  DELEGATAIRE = 'DELEGATAIRE',
  ADMIN_1 = 'ADMIN_1',
  ADMIN_2 = 'ADMIN_2',
  SIMPLE = 'SIMPLE',
}

export const RL_ADMINS_ROLES = [UtilisateurRole.REPRESENTANT, UtilisateurRole.ADMIN_1, UtilisateurRole.ADMIN_2];
export const ADMINS_ROLES = [UtilisateurRole.ADMIN_1, UtilisateurRole.ADMIN_2];
export const IAM_ROLES = [UtilisateurRole.ADMIN_1, UtilisateurRole.ADMIN_2, UtilisateurRole.SIMPLE];